import axios from 'axios'
import { getCall, postCall, putCall, patchCall } from '../../utils/apiCalls'

import {
  PAYTM_CITIES_DATA,
  ROUTE_SERVICES,
  OFFER_DATA,
  CANCELLATION_OFFER_LIST,
  CLEAR_CANCELLATION_OFFER_DATA
} from './actionTypes'

import {
  GET_PAYTM_CITIES,
  FREE_CANCELLATION,
  GET_ROUTE_SERVICES
} from '../../config/urls';

export const getOperatorRoutes = () => dispatch => {
  getCall(GET_PAYTM_CITIES)
    .then(res => {
      if(!res.data || !res.data.length) return;
      dispatch({
        type: PAYTM_CITIES_DATA,
        payload: { data: res.data || [] },
      })
    })
}

export const getCancellatinOffers = () => dispatch => {
  getCall(FREE_CANCELLATION)
    .then(res => {
      if(res && res.status === 200) {
        // in case of no data, skip the dispatch
        if(!res.data || !res.data.body || !res.data.body.length) return;

        dispatch({
          type: CANCELLATION_OFFER_LIST,
          payload: { data: res.data.body || [] },
        })
      } else {
        alert(((res.response || {}).data || {}).message || 'Unable to fetch cancellation offers, please try again.');
      }
    })
}

export const updateOfferStatus = (data, payload, callback) => dispatch => {
  const url = FREE_CANCELLATION + '/' + data.policy_id;
  patchCall(url, payload, { paytm_route: data.paytm_route })
    .then(res => {
      if (res && res.status === 200) {
        callback();
        alert('Updated Successfully.')
      } else {
        alert(((res.response || {}).data || {}).message || 'Error Occurred, please try later');
      }
    })
}

export const fetchOfferData = (policyId, paytmRoute) => dispatch => {
  getCall(FREE_CANCELLATION + '/' + policyId, { paytm_route: paytmRoute })
    .then(res => {
      if (res && res.status === 200) {
        let data = res.data.body && res.data.body.length? res.data.body[0]: [];
        dispatch({
          type: OFFER_DATA,
          payload: { data },
        })
        let ids = (data.paytm_route || '-').split('-');
        fetchServices({ srcId: ids[0], destId: ids[1] })(dispatch);
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const fetchServices = (query) => dispatch => {
  getCall(GET_ROUTE_SERVICES, query)
    .then(res => {
      let isError = (res && res.response && res.response.status >= 400) || !res.data || !res.data.body || !res.data.body.length;
      if(isError) {
        alert("No Services found for selected source and destination.");
        // clear the previous results
        dispatch({
          type: ROUTE_SERVICES,
          payload: { data: [] },
        })
        return;
      }
      dispatch({
        type: ROUTE_SERVICES,
        payload: { data: res.data || [] },
      })
    })
}

export const createOffer = (data, callback) => dispatch => {
  postCall(FREE_CANCELLATION, data)
    .then(res => {
      if (res && res.status === 200) {
        alert('Created Successfully.');
        callback();
      }
      else {
        const err = (res.response.data || {}).message || 'Error, Please try again.';
        alert(err);
      }
    })
}

export const updateOffer = (data, callback) => dispatch => {
  let url = FREE_CANCELLATION + '/' + data.policy_id;
  putCall(url, data)
    .then(res => {
      if (res && res.status === 200) {
        alert('Updated Successfully.');
        callback();
      }
      else {
        const err = (res && res.response && res.response.data || {}).message || 'Error, Please try again.';
        alert(err);
      }
    })
}

export const clearOfferData = () => ({
  type: CLEAR_CANCELLATION_OFFER_DATA
})
